<template>
    <div>
    <ListCycle v-if="isMainRoute"></ListCycle>
    <router-view></router-view>
    </div>
</template>

<script>
    import ListCycle from "@/components/cyclic/cycle/List"
    export default {
        components: {
            ListCycle
        },
        data: () => ({
            isMainRoute:true
        }),
        computed: {
        },
        name: "MainView",
        methods: {
        },
        created() {
            this.isMainRoute=this.$router.currentRoute.name == 'cycle-list'
        },
        watch: {
            '$route.name': function (name) {
               this.isMainRoute= name == 'cycle-list'
            }
        },
    }
</script>

<style scoped>

</style>